import { createContext, useEffect } from 'react'
import Swal from 'sweetalert2'
import { useSearchParams } from 'react-router-dom'

import useCommon from '../hooks/useCommon'
import useAxiosPrivate from '../hooks/useAxiosPrivate'

const CharteringContext = createContext()

const initialFilter = {
	statusIdFk: '',
	comIdFk: '',
	subBookIdFk: '',
	cargoIdFk: '',
	startFrom: '',
	startTo: ''
}

export const CharteringProvider = ({ children }) => {
	const axiosPrivate = useAxiosPrivate()
	const [searchParams] = useSearchParams()
	const id = searchParams.get('id')

	const {
		isUpdate,
		setIsUpdate,
		isShowModal,
		setIsShowModal,
		loadingRecord,
		setLoadingRecord,
		loadingTableList,
		setLoadingTableList,
		tableList,
		setTableList,
		tablePaging,
		setTablePaging,
		dataInFilter,
		setDataInFilter,
		dataInControl,
		setDataInControl,
		filter,
		setFilter,
		selectedItem,
		setSelectedItem,
		handleChangeFilter,
		handleResetFilter,
		fetchDataList,
		fetchDataInFilter,
		fetchDataInControl,
		handleOrder,
		deleteRecord,
		handleCloseModal,
		saveDraft,
		loadingSave,
		publishItem,
		exportExcel
	} = useCommon('POP_Tanker', initialFilter)

	useEffect(() => {
		if (id) {
			fetchDataList({ recordId: parseInt(id) })
		} else {
			fetchDataList()
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [id])

	useEffect(() => {
		fetchDataInFilter()
		fetchDataInControl()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const fetchDataRecord = async id => {
		setLoadingRecord(true)

		try {
			const { data } = await axiosPrivate.get(`/POP_Tanker/DataRecord?id=${id}`)

			setSelectedItem({
				...data.data?.table[0],
				listItems: data.data?.table1
			})
			setIsUpdate(true)
			setIsShowModal(true)
		} catch (err) {
			Swal.fire({
				title: 'Error!',
				text: err.response?.data?.message ?? err.response?.data?.title,
				icon: 'error',
				confirmButtonText: 'Ok'
			})
		} finally {
			setLoadingRecord(false)
		}
	}

	const copyItem = async (keyName, id) => {
		setLoadingRecord(true)

		try {
			const { data } = await axiosPrivate.get(`/POP_Tanker/DataRecord?id=${id}`)

			setSelectedItem({
				...data.data?.table[0],
				[keyName]: 0,
				listItems: data.data?.table1
			})
			setIsUpdate(true)
			setIsShowModal(true)
		} catch (err) {
			Swal.fire({
				title: 'Error!',
				text: err.response?.data?.message ?? err.response?.data?.title,
				icon: 'error',
				confirmButtonText: 'Ok'
			})
		} finally {
			setLoadingRecord(false)
		}
	}

	return (
		<CharteringContext.Provider
			value={{
				isUpdate,
				setIsUpdate,
				isShowModal,
				setIsShowModal,
				loadingRecord,
				setLoadingRecord,
				loadingTableList,
				setLoadingTableList,
				tableList,
				setTableList,
				tablePaging,
				setTablePaging,
				dataInFilter,
				setDataInFilter,
				dataInControl,
				setDataInControl,
				filter,
				setFilter,
				selectedItem,
				setSelectedItem,
				handleChangeFilter,
				handleResetFilter,
				fetchDataList,
				fetchDataInFilter,
				fetchDataInControl,
				fetchDataRecord,
				handleOrder,
				deleteRecord,
				handleCloseModal,
				saveDraft,
				loadingSave,
				publishItem,
				copyItem,
				exportExcel
			}}
		>
			{children}
		</CharteringContext.Provider>
	)
}

export default CharteringContext
